<template>
  <div v-if="!$auth.loading">
    <h1 class="bd-title pageTitle" id="content">RFQ</h1>
    <loading-view v-if="loading" />
    <b-form @submit.stop.prevent>
      <b-container fluid>
          <b-form-row>
            <b-col lg="6" md="6" sm="12">
                <b-form-group id="input" label="Search:" label-for="input-search">
                    <b-form-input
                        id="input-search_string"
                        v-on:keyup="onKeyPressed"
                        v-model="input"
                        placeholder="Enter RFQ #, NSN, Part Number, ..."
                        v-bind:autofocus="true"
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="4" sm="12">
                <b-form-group id="opportunity" label="Opportunity Status:" label-for="input-filter">
                    <b-form-select 
                        id="input-filter"
                        v-model="opportunityIsActiveOnly"
                        placeholder="Filter"
                        :options="options"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col lg="2" md="2" sm="12">
                <b-form-group label=" ‎">
                    <b-button block variant="primary" v-on:click="onSearch">Search</b-button>
                </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
              <b-col lg="6" md="6" sm="12">
                <b-form-group>
                    <b-form-checkbox
                        id="not-quoted-checkbox"
                        v-model="isNotQuoted"
                        size="lg"
                        @change="onSearch"
                    >
                        Show RFQs without responses
                    </b-form-checkbox>
                </b-form-group>
              </b-col>
          </b-form-row>
        <rfq-summaries
            v-bind:response="rfqs_response"
            v-bind:hasMore="has_more"
            v-on:loadMore="onLoadMore"
        />
      </b-container>
    </b-form>
  </div>
</template>


<script>
const PortalApi = require("@brightoncromwell/portal-api");
const rfqsApiInstance = new PortalApi.RfqsApi();
let defaultClient = PortalApi.ApiClient.instance;

import RfqSummaries from "@/components/rfqs/RfqSummaries";
import LoadingView from '@/components/common/LoadingView';
import { datadogLogs } from '@datadog/browser-logs';
import { getInstance } from '../../auth';

export default {
  name: "rfqs",
  metaInfo: {
    title: "rfqs"
  },
  components: {
    "rfq-summaries": RfqSummaries,
    'loading-view': LoadingView
  },
  data() {
    return {
      limit: 10,
      offset: 0,
      input: "",
      rfqs_response: [],
      has_more: false,
      loading: false,
      isNotQuoted: false,
      opportunityIsActiveOnly: true,
      options: [
          { value: true, text: "Show Only Active" },
          { value: false, text: "Show All" }
        ]
    };
  },
  methods: {
    createResponse: function(rfqs) {
      console.log(rfqs)
      return rfqs.items.map(item => ({
        id: item.id,
        label: item.label,
        receivedTs: item.received_ts,
        sentTs: item.sent_ts,
        returnByTs: item.return_by_ts,
        receivingCageCode: item.receiving_cage_code,
        opportunities: item.opportunities.map(opportunity => ({
          id: opportunity.id,
          label: opportunity.label,
          isActive: opportunity.is_active,
          openTs: opportunity.open_ts,
          closeTs: opportunity.close_ts
        }))
      }));
    },
    getRfqs: async function() {
      this.loading = true;
      this.has_more = false;
      const token = await this.getToken();
      console.log("PAR: " + this.$parent.selected);
      
      const opts = {
        offset: this.offset,
        limit: this.limit,
        search: this.input,
        opportunityIsActiveOnly: this.opportunityIsActiveOnly,
        isNotQuoted: this.isNotQuoted ? true : null,
        companyId: localStorage.getItem('selected_company_id'),
        filterPRJs: true
      };

      datadogLogs.logger.info('Getting RFQ list', opts);
      
      let BearerAuth = defaultClient.authentications['BearerAuth'];
      BearerAuth.accessToken = token;
      
      rfqsApiInstance.rfqsGet(opts, (error, data, response) => {
        console.log(opts)
        if (error) {
          console.error(error);
          if(error == "login_required"){
                  window.location.href = "/signin";
          }
          this.$emit('onError', response)
        } else {
          console.log('rfqsApiInstance.rfqsGet succeeded');
          const rfqs = this.createResponse(data);
          this.has_more = !(rfqs.length < this.limit);
          this.rfqs_response = this.rfqs_response.concat(rfqs);
        }
        this.loading = false;
      });
    }, 
    // $auth isn't loaded in by the time the page tries to get the token, so we need to do some extra steps in order to wait
    getToken: async function(){
      return new Promise((resolve, reject) => {
        const instance = getInstance();
        if(instance.loading == false){
          // Redirect if the user isn't authenticated
          if (!instance.isAuthenticated){
            window.location.href = "/signin";
          }
          resolve(instance.getTokenSilently());
        }
        else{
        instance.$watch("loading", loading => {
            if (loading == false && instance.isAuthenticated){
              instance.getTokenSilently().then(authToken => {resolve(authToken);}).catch(error => {
              if(error == "login_required"){
                  window.location.href = "/signin";
                }
              reject(error);
              });
            }
            // Redirect if the user isn't authenticated
            else if (!instance.isAuthenticated){
              window.location.href = "/signin";
            }
          });
        }
      });
    },
    onKeyPressed: function(e) {
      if (e.keyCode === 13) {
        this.onSearch();
      }
    },
    onSearch: function() {
      this.offset = 0;
      this.rfqs_response = [];
      this.getRfqs();
    },
    onLoadMore: function() {
      this.offset = this.offset + this.limit;
      this.getRfqs();
    }
  },
  created() {
    this.onSearch();
  },
  mounted() {
    datadogLogs.logger.info('RFQ List page displayed', {});
  }
};
</script>
